import { useQuery } from "@tanstack/react-query";
import { LuFileCheck2 } from "react-icons/lu";
import { Link } from "react-router-dom";
import { handleFetchRequestsCount } from "../../api/requests";

export default function ManageApproved() {
  const { data: count } = useQuery({
    queryKey: ["approvedCount"],
    queryFn:() => handleFetchRequestsCount({ status: 'approved' }),
  });
  return (
    <Link
      to={`/requests/status/approved`}
      className={`col-span-6 sm:col-span-4 lg:col-span-2 bg-green-100 p-4 border border-green-200`}

    >
      <div className="flex justify-between">
        <div className="flex flex-col justify-center items-center">
          <div className="flex items-center">
            <LuFileCheck2 color="#323232" size={24} />
          <div className="mx-2">Approved Requests</div>
          </div>
        </div>
        <div className="font-bold">{count}</div>
      </div>
    </Link>
  );
}
